export const tempPagination = {
  pageNum: 1,
  pageSize: 10,
  total: 0,
  pageSizes: [5, 10, 20, 50],
}
export const tempOLoading = {
  search: false,
}
